import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { REDUX } from '../../constants';
import authService from '../../services/authService';

const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
  loading: false,
  error: null,
};

const loginUser = createAsyncThunk(
  `${REDUX.AUTH_SLICE}${REDUX.LOGIN_SUFFIX}`,
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await authService.login(credentials);
      return response;
    } catch (error) {
      const message =
        error instanceof Error ? error.message : 'An unexpected error occurred';
      return rejectWithValue(message);
    }
  }
);

const registerUser = createAsyncThunk(
  `${REDUX.AUTH_SLICE}${REDUX.REGISTER_SUFFIX}`,
  async (data, { rejectWithValue }) => {
    try {
      const response = await authService.register(data);
      return response;
    } catch (error) {
      const message =
        error instanceof Error ? error.message : 'An unexpected error occurred';
      return rejectWithValue(message);
    }
  }
);

const authSlice = createSlice({
  name: REDUX.AUTH_SLICE,
  initialState,
  reducers: {
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      state.error = null;
    },
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Login
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user;
        state.token = action.payload.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.user = null;
        state.token = null;
        state.error = action.payload;
      })

      // Register
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user;
        state.token = action.payload.token;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.user = null;
        state.token = null;
        state.error = action.payload;
      });
  },
});

export const { logout, clearError } = authSlice.actions;
export { loginUser, registerUser };
export default authSlice.reducer;
